(function () {
  function enhancePdp() {
    var pdp = document.querySelector('.pdp--journey');
    if (!pdp) return;

    var zoom = pdp.querySelector('[data-gallery-zoom]');
    if (zoom) zoom.remove();

    var swatchFieldset = pdp.querySelector('.pdp__options--swatch');
    if (swatchFieldset && !swatchFieldset.querySelector('.pdp__compare-guide')) {
      var compareLink = document.createElement('a');
      compareLink.className = 'pdp__compare-guide';
      compareLink.href = '/pages/comparatif-diffuseurs';
      compareLink.textContent = 'Comparer les diffuseurs';
      swatchFieldset.appendChild(compareLink);
    }

    var title = pdp.querySelector('.pdp__title');
    if (title && title.textContent.trim().toLowerCase().indexOf('darcy') !== -1 && !pdp.querySelector('.pdp__limited-badge')) {
      var limitedBadge = document.createElement('span');
      limitedBadge.className = 'pdp__limited-badge';
      limitedBadge.textContent = 'Édition limitée';
      title.parentNode.insertBefore(limitedBadge, title);
    }  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhancePdp);
  else enhancePdp();
  document.addEventListener('shopify:section:load', enhancePdp);
})();
